import { render, staticRenderFns } from "./AuthorInfo.vue?vue&type=template&id=1a499f26&scoped=true"
import script from "./AuthorInfo.vue?vue&type=script&lang=js"
export * from "./AuthorInfo.vue?vue&type=script&lang=js"
import style0 from "./AuthorInfo.vue?vue&type=style&index=0&id=1a499f26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.7.3_webpack@5.80.0__ejs@3.1.9_lodash@4.17.21_vue-template-compiler@2.7.14_webpack@5.80.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a499f26",
  null
  
)

export default component.exports